module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/sendbird/~/axios/index.js
// module id = 1006
// module chunks = 42